import React, { useEffect, FC } from "react"
import { useRecoilValue } from "recoil"
import { useSession } from "../../hooks/useSession"
import { idleTimeoutTime } from "../../utils/constants"
import { transcriptRecordingState } from "../../utils/store"

export const IdleLogout: FC<{ children: React.ReactNode }> = ({ children }) => {
  const { logout } = useSession()
  const isTranscriptRecording = useRecoilValue(transcriptRecordingState)

  useEffect(() => {
    const events = ["mousemove", "scroll", "keydown"]

    let timer: number | null = null

    const clearTimer = () => {
      if (timer !== null) {
        window.clearTimeout(timer)
        timer = null
      }
    }

    const restartTimer = () => {
      clearTimer()

      // Don't log out on idle if scribe is recording
      if (isTranscriptRecording) {
        return
      }
      timer = window.setTimeout(() => {
        void logout()
      }, idleTimeoutTime)
    }

    events.forEach((event) => window.addEventListener(event, restartTimer))
    restartTimer()

    return () => {
      clearTimer()
      events.forEach((event) => window.removeEventListener(event, restartTimer))
    }
  }, [isTranscriptRecording, logout])

  return <>{children}</>
}

export default IdleLogout
